<template>
  <div class="business-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="标题名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题名称" class="input" />
      </el-form-item>
      <el-form-item label="商场" prop="mallId">
        <el-select v-model="form.mallId" placeholder="请选择商场">
          <el-option v-for="(item, index) in mallOption" :label="item.name" :value="item.id" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面图" prop="cover">
        <UploadImg @getUploadFile="(file)=>{ this.form.cover = file }" :uploadUrl="form.cover" :desc="'建议：上传1214*574的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="详情">
        <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(100% - 40px);">
          <!-- 工具栏 -->
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
          />
          <!-- 编辑器 -->
          <Editor
            style="height: 600px; overflow-y: hidden;"
            :defaultConfig="editorConfig"
            v-model="form.detail"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import editor from '@/mixins/editor'
import { api_getMallDesc, api_postMallDesc, api_putMallDesc } from '@/api/business'
import { api_postFileUpload, api_getConfig } from '@/api/common'
export default {
  name: "infoCreate",
  mixins: [ editor ],
  components: {
    UploadImg,
    Editor,
    Toolbar
  },
  data() {
    return {
      form: {
        mallId: '',
        name: '',
        cover: '',
        detail: '',
      },
      mallOption: [],
      rules: {
        mallId: [{ required: true, message: '请选择商场' }],
        name: [{ required: true, message: '请输入标题名称' }],
        cover: [{ required: true, message: '请上传封面图' }],
        detail: [{ required: true, message: '请输入详情' }],
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/商场介绍<span class="black">/编辑商场介绍</span></span>'
      this.getInfo()
    } else {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/商场介绍<span class="black">/创建商场介绍</span></span>'
    }
    this.getConfigData()
  },
  methods: {
    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall} = await api_getConfig(['mall'])
      this.mallOption = mall
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            if (this.form.cover.size) {
              const { key } = await api_postFileUpload(this.form.cover, 'MallImg')
              params.cover = key
            }
            this.$route.query.id ? await api_putMallDesc({...params, id: this.$route.query.id}) : await api_postMallDesc(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    // 获取详情数据
    async getInfo () {
      const data = await api_getMallDesc({id: this.$route.query.id})
      let { mallId, name, cover, detail } = data
      this.form = { mallId, name, cover, detail }
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.business-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
